module.exports = __webpack_public_path__ + "img/lv20.a7f75bf7.png";